<template>
  <div>
    <div class="face_header">
      <div class="face_header_con">
        <p class="face_header_lf">{{ this.testInfo.examName }}</p>
        <a class="face_header_rg" @click="logoutHandle">
          <span class="headsp"><img src="@/assets/images/exit.png"/></span>
          退出
        </a>
        <router-link to="/resetPassword" class="face_header_rg">
          <span class="headsp"><img src="../assets/images/icon-user.png"/></span
          >{{ this.userInfo.userName }}
        </router-link>
      </div>
    </div>
    <!-- <div class="query_tit">
      <ul>
        <a href="javascript:void(0);" @click="readNotice()">1、阅读考试须知</a
        >&nbsp;&nbsp;&nbsp;&nbsp;
        <a href="javascript:void(0);" @click="confirmInfo()">2、确认个人信息</a>
      </ul>
    </div> -->
    <div class="bg_all">
      <div class="exam_stru_con">
        <h1>{{ testInfo.examName }}</h1>
        <!-- <p>科目：{{ testInfo.oneWord }}</p> -->
        <p>时间：{{ testInfo.answerLength }}分钟</p>
        <p>总分：{{ testInfo.scoreTotal }}分</p>
        <h3 v-if="testInfo.etList !== undefined">
          共分为{{ testInfo.etList.length }}个部分：<span class="str_djs">
            0{{ hours }}:<span v-if="this.minutes < 10">0{{ minutes }}</span>
            <span v-else>{{ minutes }}</span
            >:<span v-if="this.seconds < 10">0{{ seconds }}</span>
            <span v-else>{{ seconds }}</span>
          </span>
        </h3>
        <ul>
          <li v-for="et in testInfo.etList" :key="et.exerciseTypeId">
            {{ et.exerciseTypeName }}({{ et.description }})<span
              >{{ et.scoreTotal }}分</span
            >
          </li>
        </ul>
        <div class="dt_btn">
          <!-- <a href="javascript:void(0)" @click="exit">退出考试</a> -->
          <a style="position: absolute;left: 50%;transform: translateX(-50%);" href="javascript:void(0)" @click="startExam">{{btnContent}}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
window.addEventListener(
  "popstate",
  function(e) {
    this.history.forward();
    console.log(e);
  },
  false
);
import { getTestInfo, logout, getServerTime, sendStopPushStreamMsg } from "@/api/login";
export default {
  name: "ExamCatalog",
  data() {
    return {
      btnContent: "开始作答",
      totalTime: 30,
      examBean: {
        token: "",
        examUserId: ""
      },
      tokenBean: {
        token: ""
      },
      testInfo: {},
      hours: 0,
      minutes: 0,
      seconds: 59,
      timer1: "",
      serverTime: "",
      code: ""
    };
  },
  created() {
    this.tokenBean.token = this.getToken();
    this.examBean.token = this.getToken();
    this.examBean.examUserId = this.$route.query.examUserId;
    // this.code = window.location.href;
    // this.code = this.code.substring(this.code.indexOf("?") + 1);
    // console.log("1111111=" + this.code);
    // this.code = this.code.substring(0, this.code.indexOf("&"));
    // if (this.code !== "") {
    //   console.log("22222=" + this.code);
    //   this.code = this.code.substring(this.code.indexOf("=") + 1);
    //   console.log("33333=" + this.code);
    //   if (this.code !== "0") {
    //     this.$message.error("人脸核身失败，请重新验证。");
    //     this.$router.push({
    //       path: "/examNeedToKnow",
    //       query: { examUserId: this.examBean.examUserId }
    //     });
    //   }
    // }
    this.initData();
  },
  computed: {
    userInfo() {
      return this.getUserInfo();
    }
  },
  methods: {
    initData() {
      getServerTime().then(res => {
        if (res.code === 200) {
          this.serverTime = res.data.dateTime;
          getTestInfo(this.examBean).then(res => {
            if (res.code === 200) {
              this.testInfo = res.data;
              const startDate = Date.parse(this.testInfo.examTime); // 开始考试时间
              const answerLength = this.testInfo.answerLength; //允许考试的时长
              const currentDate = Date.parse(this.serverTime); //服务器当前时间
              const mi = answerLength - (currentDate - startDate) / 60000;
              // console.log("mi=" + mi);
              this.seconds = parseInt(mi * 60) % 60;
              // console.log("second=" + this.seconds);
              this.minutes = parseInt(mi);
              if (this.minutes > 0) {
                this.hours = parseInt(this.minutes / 60);
                this.minutes = this.minutes % 60;
              }
              this.timer1 = setInterval(this.setExamTime, 1000);
            } else if (res.code === 8002) {
              this.exit();
            } else if (res.code === 8001) {
              this.$router.push("/curExam");
              return;
            } else if (res.code === 8003) {
              this.$router.push("/login");
              return;
            } else {
              this.$router.push("/curExam");
              return;
            }
          });
        }
      });
      this.countDown();
    },

    countDown() {
      this.btnContent = '开始作答（'+this.totalTime+'）';
      let clock = window.setInterval(() => {
        this.totalTime--;
        this.btnContent = '开始作答（'+this.totalTime+'）';
        if (this.totalTime < 0) {
            window.clearInterval(clock);
            this.startExam();
        }
      },1000)
    },

    //显示考试时间
    setExamTime() {
      if (this.minutes === 0 && this.hours === 0 && this.seconds === 0) {
        clearInterval(this.timer1);
        return;
      }
      if (this.minutes === 0 && this.hours !== 0) {
        this.minutes = 60;
        this.hours = this.hours - 1;
      }
      if (this.seconds === 0) {
        this.seconds = 60;
        this.minutes = this.minutes - 1;
      }
      this.seconds = this.seconds - 1;
    },
    exit() {
      if(this.testInfo.backCamera === 2) {
        sendStopPushStreamMsg(this.examBean);
      }
      this.$router.push("/curExam");
    },
    startExam() {
      this.$router.push({
        path: "/exam",
        query: { examUserId: this.examBean.examUserId }
      });
    },
    readNotice() {
      this.$router.push({
        path: "/examNeedToKnow",
        query: { examUserId: this.examBean.examUserId }
      });
    },
    confirmInfo() {
      this.$router.push({
        path: "/confirmProfile",
        query: { examUserId: this.examBean.examUserId }
      });
    },
    logoutHandle() {
      if (confirm("退出确认")) {
        logout(this.tokenBean).then(res => {
          if (res.code === 200) {
            this.removeUserInfo();
            this.$router.push("/login");
          }
        });
      }
    }
  }
};
</script>

<style scoped></style>
